import React from 'react'
import './newsthrought.scss'
import { Sidebar, MainHeading, Breadcrumb, CommonTabs, NewsThroughtData , CommonCard , NewsCard } from '../../../components';
import { images } from "../../../utils/customFn";
import { Row, Col, Container } from 'react-bootstrap';
import LeadershipCardData from "./data.json";
const NewsThrought = () => {
  const breadcrumbs = [
    { label: "Sentry Insurance home", link: "/" },
    { label: "About us", link: "/aboutus" },
    { label: "Company news and events", link: "/aboutus/newsthrought" },
  ];

  const tabsData = [
    {
      id: "Throught",
      href: "#/",
      label: "Thought leadership",
    },
    {
      id: "Featured",
      href: "#/",
      label: "Featured stories",
    },
  ];
  
  const NewsCardData = [
    {
      id: 1,
      title: '2024 Retail & Wholesale Injury Report: Protecting new hires',
      description:
        'Our new report shows higher injury rates among first-year workers in retail and wholesale operations. Dan Grant and Jean Feldman share their tips and insights.',
      linkUrl: '',
      linkText: 'Learn more >',
    },
    {
      id: 2,
      title: 'Sentry employees raise $1.7 million for United Way',
      description:
        'Sentry Insurance employees come together during their annual United Way campaign, raising $1.7 million to support their communities.',
      linkUrl: '/',
      linkText: 'Learn more >',
    },
    {
      id: 3,
      title: 'Innovative optionsDeloitte ranks Sentry No. 13 on Wisconsin 75',
      description:
        'Sentry moved up one spot on the 2024 Wisconsin 75. Its success reflects a long-term growth strategy, forecast to continue in 2025.',
      linkUrl: '/',
      linkText: 'Learn more >',
    },
  ];


  const activeTabId = "Throught";
  return (
    <>
      <Container>
        {/* Breadcrumb */}
        <Breadcrumb crumbs={breadcrumbs} />

        {/* heading  */}
        <MainHeading title="Sentry news and thought leadership" />

        {/* Layout */}
        <Row>
          <Col sm={12} md={7} lg={8} xl={8}>
            <NewsThroughtData />
          </Col>
          <Col sm={12} md={5} lg={4} xl={4}>
            <Sidebar />
          </Col>
        </Row>
        <div className='bottom-container'>
          <CommonTabs tabs={tabsData} activeTab={activeTabId} />
          <CommonCard Title="Thought leadership" CardData={LeadershipCardData} colSizes={{lg: 6, xl: 6 }}/>
          <NewsCard Title="Featured stories" CardData={NewsCardData}/>
        </div>
      </Container>
    </>
  )
}

export default NewsThrought